'use client';
import { useCart } from '@/contexts/CartContext';

export default function FinalCTASection() {
  const { addToCart, inventory } = useCart();

  const handleAddToCart = () => {
    if (inventory > 0) {
      addToCart({
        id: 'igniss-001',
        name: 'IGNISS // 001',
        price: 49,
        quantity: 1,
        image: 'https://images.unsplash.com/photo-1602874801006-e0c4c93c7c3c?w=400',
      });
    }
  };

  const isSoldOut = inventory === 0;

  return (
    <section className="py-32 px-6 bg-card reveal">
      <div className="max-w-5xl mx-auto text-center space-y-12">
        <div className="space-y-8">
          <p className="text-2xl md:text-3xl text-muted-foreground leading-relaxed max-w-2xl mx-auto">
            Only 1,000 units exist.
          </p>

          <h2 className="text-5xl md:text-6xl font-serif font-bold tracking-tight leading-none text-foreground">
            If this page is live, <br className="hidden md:block" />
            <span className="italic font-normal text-primary">some are still available.</span>
          </h2>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          {isSoldOut ? (
            <div className="bg-muted text-muted-foreground px-12 py-6 rounded-full text-xl font-bold inline-block">
              Sold Out — Never Restocked
            </div>
          ) : (
            <button 
              onClick={handleAddToCart}
              className="group flex items-center justify-center gap-3 bg-primary text-primary-foreground px-12 py-6 rounded-full text-xl font-bold hover:bg-foreground hover:text-background smooth-hover shadow-xl"
            >
              Add to Cart
              <svg
                className="w-6 h-6 group-hover:translate-x-1 transition-transform"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 7l5 5m0 0l-5 5m5-5H6"
                />
              </svg>
            </button>
          )}
        </div>
      </div>
    </section>
  )
}